module.exports = __webpack_public_path__ + "media/images/pic/sample2-b20f6e865ac743e8639242016b47e25e.jpg";